import { defineRecipe } from '@chakra-ui/react';

const Link = defineRecipe({
  base: {
    textDecoration: 'underline',
    fontWeight: 'normal !important',
  },
  variants: {
    visual: {
      purple: {
        color: 'podcastPurple',
        _hover: {
          color: 'podcastPurple',
        },

        _visited: {
          color: 'podcastPurple800',
        },
      },
      grey: {
        color: 'podcastShade600',
        _hover: {
          color: 'podcastShade700',
        },
        _visited: {
          color: 'podcastShade500',
        },
      },
    },
  },
  defaultVariants: {
    visual: 'purple',
  },
});

export default Link;
